import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { useCarouselContext } from '~/shared/components/CarouselContext';
import { carouselGridCarouselOptions } from '~/shared/constants/productGrid';
import {
  desktop,
  Carousel as BaseCarousel,
  useBreakpoint,
} from '~/techstyle-shared/react-components';
import { ProductListViewedProvider } from '~/techstyle-shared/react-products';

const CarouselContainer = styled.div``;

const cellStyle = css`
  margin-right: 16px;
  width: clamp(34vw, 42%, 100%);
  ${desktop`
    margin-right: 39px;
    aspect-ratio: 281/435;
    width: 281px;
  `}
`;

const cellStyle2 = css`
  margin-right: 9px;
  width: 167px;
  ${desktop`
    margin-right: 39px;
    width: 281px;
  `}
`;

const Carousel = styled(BaseCarousel).attrs(({ groupCells }) => {
  return {
    cellStyle: groupCells === 2 ? cellStyle2 : cellStyle,
  };
})`
  width: 100%;
`;

export default function ProductGridCarousel({ breakpoint, children }) {
  const { isMobile } = useBreakpoint();

  const { setFlickity } = useCarouselContext();
  const flickityRef = useCallback(
    (flickityNode) => {
      if (flickityNode) {
        setFlickity(flickityNode);
      }
    },
    [setFlickity]
  );

  const wrapperStyle = css`
    ${({ theme }) => theme.gridStyles.carouselWrapperStyle};
  `;

  const defaultCarouselOptions = {
    wrapAround: true,
    flickityRef,
    pageDots: false,
    adaptiveHeight: true,
    cellAlign: 'left',
    groupCells: breakpoint.columns ?? false,
    selectedAttraction: isMobile ? 0.025 : 0.01,
    friction: isMobile ? 0.28 : 0.21,
    draggable: isMobile,
    freeScroll: isMobile,
    wrapperStyle,
  };

  const carouselOptions = {
    ...defaultCarouselOptions,
    ...carouselGridCarouselOptions,
  };

  return (
    <ProductListViewedProvider>
      <CarouselContainer>
        <Carousel {...carouselOptions}>{children}</Carousel>
      </CarouselContainer>
    </ProductListViewedProvider>
  );
}

ProductGridCarousel.propTypes = {
  breakpoint: PropTypes.object,
  carouselOptions: PropTypes.object,
  children: PropTypes.node,
};
